import {CategoryWrapper} from './CategoryWrapper';


export default function CategoryProjectsPage() {
    return (
        <CategoryWrapper/>
    )

}